import { Box, Container, SimpleGrid, Stack, Text } from "@chakra-ui/react";

export default function LargeWithLogoLeft() {
  return (
    <Box bg="black" color="white">
      <Container as={Stack} maxW={"6xl"} py={10}>
        <SimpleGrid
          templateColumns={{ sm: "1fr 1fr", md: "2fr 1fr 1fr 1fr 1fr" }}
          spacing={8}
        >
          <Stack spacing={6}>
            <Box>Miss.Y Cake</Box>
            <Text fontSize={"sm"}>2-1456 11th AVE</Text>
            <Text fontSize={"sm"}>Regina SK, S4P 0G9</Text>
            <Text fontSize={"sm"}>(306)-502-3887</Text>
            <Text fontSize={"sm"}>meilin1978@hotmail.com</Text>
            <Text fontSize={"sm"}>© 2022 Miss.Y Cake. All rights reserved</Text>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  );
}
